import { ButtonHTMLAttributes } from 'react'

export enum UI_BUTTON_TYPE {
   PRIMARY = "PRIMARY",
   SECONDARY = "SECONDARY",
   OUTLINE = "OUTLINE",
   SECONDARY_DARKEN = "SECONDARY-DARKEN",
   PRIMARY_OUTLINE = "PRIMARY-OUTLINE",
}

export interface AppButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
   /* Content wyświetlany w przycisku, może to być tekst, lub komponent */
   children: React.ReactNode | React.ReactNode[];
   /* Funkcja wywoływana po kliknięciu przycisku */
   onClick: (e: React.MouseEvent<HTMLButtonElement>) => void | Promise<void>;
   /* Flaga oznaczająca ładowanie się przycisku */
   isLoading?: boolean;
   /* Flaga oznaczająca czy przycisk jest aktywny */
   disabled?: boolean;
   /* Typ przycisku określający jego styl */
   uiButtonType?: UI_BUTTON_TYPE;
   /** Dodatkowa klasa pozwalająca dodać customowe właściwości */
   className?: string
}